export default {
	global: {
		yes: 'Sí',
		no: 'No',
		email: 'Correo electrónico',
		password: 'Contraseña',
		account: 'Cuenta',
		phone_number: 'Número de Teléfono',
		go_back: 'Volver',
		resend: 'Reenviar',
		view: 'Ver',
		delete: 'Eliminar',
		created: 'Creado',
		status: 'Estado',
		reason: 'Razón',
		type: 'Tipo',
		level: 'Nivel',
		message: 'Mensaje',
		details: 'Detalles',
		username: 'Nombre de usuario',
		retry: 'Rever',
		data: 'Datos',
		save: 'Guardar',
		verify: 'Verificar',
		reverify: 'Reverificar',
		upload: 'Subir',
		answer: 'Responder',
		close: 'Cerrar',
		publish: 'Publicar',
		unpublish: 'Despublicar',
		workflow: 'Flujo de Trabajo',
		continue: 'Continuar',
		name: 'Nombre',
		role: 'Rol',
		invite: 'Invitar',
		pending: 'Pendiente',
		mobile: 'Móvil',
		office: 'Oficina',
		home: 'Hogar',
		people: 'Personas',
		add: 'Agregar',
		added_on: 'Agregado el',
		settings: 'Configuración',
		file_name: 'Nombre del archivo',
		file_id: 'ID del archivo',
		rename: 'Renombrar',
		edit: 'Editar',
		download: 'Descargar',
		untitled: 'Sin título',
		folder: 'Carpeta',
		search: 'Buscar',
		clear_search: 'Limpiar búsqueda',
		sort_by: 'Ordenar por',
		sort_direction: 'Dirección de orden',
		created_at: 'Fecha de creación',
		start_date: 'Fecha de inicio',
		end_date: 'Fecha de fin',
		error: 'Hubo un error al obtener los datos',
		accounts: 'Cuentas',
		need_help: '¿Necesitas ayuda?',
		log: {
			title: 'Registros',
			created_at: 'Fecha de creación',
			level: 'Nivel',
			message: 'Mensaje',
		},
		bulk_select: 'Selección masiva',
	},
	auth: {
		sign_in: 'Iniciar sesión',
		dont_have_an_account: '¿No tienes una cuenta?',
		check_inbox_for_invite_from_loan_officer:
			'Por favor, revisa tu bandeja de entrada para una invitación de tu Oficial de Préstamos',
		forgot_my_password: 'Olvidé mi contraseña',
		existing_user_account_detected:
			'Se detectó una cuenta de usuario existente',
		sign_in_to_account: 'Inicia sesión en tu cuenta',
		already_have_an_account: '¿Ya tienes una cuenta?',
	},
	loans: {
		loan_id: 'ID del préstamo',
		not_assigned: 'No asignado',
		loan_users: 'Usuarios del Préstamo',
		loan_contacts: 'Contactos del Préstamo',
	},
	loan_queue: {
		loan_queue: 'Cola de préstamos',
		loan_queue_record: 'Registro de cola de préstamos',
		type: {
			new_loan: 'Nuevo préstamo',
			new_cob_loan: 'Nuevo préstamo con co-prestatario',
			loan_update: 'Actualizar solicitud',
			field_update: 'Actualizar campo',
			document_upload: 'Subir documento',
			new_buckets: 'Nuevos contenedores',
		},
		job_id: 'ID de trabajo',
	},
	loan_import: {
		loan_import: 'Importaciones de préstamos',
		imported_count: 'Cantidad importada',
		import_mode: 'Modo de importación',
		attempt_count: 'Número de intentos',
		status: 'Estado',
		status_filter: 'Filtro de Estado',
		status_message: 'Mensaje de Estado',
		created_at: 'Fecha de creación',
		date_range: 'Período',
		account_id: 'ID de cuenta',
		new_loan_import: 'Nueva importación de préstamos',
		edit_loan_import: 'Editar importación de préstamos',
		details: 'Detalles de la importación de préstamos',
		create_loan_import: 'Crear importación de préstamos',
		update_loan_import: 'Actualizar importación de préstamos',
		add_loan_import: 'Agregar importación de préstamos',
		remove_operation_not_implemented:
			'Operación de eliminación no implementada todavía',
		loading_problem:
			'Hubo un problema al cargar las importaciones de préstamos',
		invalid_date_range:
			'Rango de fechas inválido. La fecha de inicio debe ser anterior o igual a la fecha de fin, y la fecha de fin no puede estar en el futuro.',
		create_success: 'Importación de préstamos creada con éxito',
		status_options: {
			show_all: 'Mostrar Todos',
			waiting_process: 'Esperando Proceso',
			in_progress: 'En Progreso',
			completed: 'Completado',
			failed: 'Fallido',
			cancelled: 'Cancelado',
		},
		import_mode_options: {
			all: 'Todos',
			new_only: 'Solo Nuevos',
			update_only: 'Solo Actualizaciones',
		},
	},
	loan_log: {
		type: {
			loan: 'Préstamo',
			queue: 'Cola',
			pos_flag_changed: 'Bandera POS Cambiada',
			verification: 'Verificación',
		},
		level: {
			none: 'Ninguno',
			info: 'Información',
			warning: 'Advertencia',
			error: 'Error',
		},
	},
	users: {
		loan_officer: 'Oficial de préstamos',
	},
	validation: {
		email: {
			required: 'El correo electrónico es obligatorio',
			invalid: 'El correo electrónico no es válido',
			unique_borrower:
				'Cada prestatario debe tener una dirección de correo electrónico única',
		},
		password: {
			required: 'La contraseña es obligatoria',
			minLength:
				'La contraseña debe tener al menos {minLength} caracteres',
			create: 'Crear contraseña',
			confirm: 'Confirmar contraseña',
		},
		phone: {
			invalid: 'El número de teléfono no es válido.',
			required: 'El número de teléfono es obligatorio',
		},
		name: {
			first_name_invalid: 'El nombre no es válido',
			last_name_invalid: 'El apellido no es válido',
			first_name_required: 'El primer nombre es obligatorio',
			last_name_required: 'El apellido es obligatorio',
		},
		file_name: {
			required: 'El nombre del archivo es obligatorio',
			no_periods: 'El nombre del archivo no puede contener puntos',
		},
		date: {
			select_valid_date: 'Por favor, seleccione una fecha válida',
			start_date_future:
				'La fecha de inicio no puede estar en el futuro',
			end_date_future: 'La fecha de fin no puede estar en el futuro',
			end_date_before_start:
				'La fecha de fin debe ser en o después de la fecha de inicio',
			start_date_required: 'La fecha de inicio es obligatoria',
			end_date_required: 'La fecha de fin es obligatoria',
		},
	},
	errors: {
		general: 'Hubo un error al procesar la solicitud',
		error_loading:
			'Hubo un problema al recuperar la información solicitada',
		invalid_credentials: 'Usuario y/o contraseña inválidos',
		account_doesnt_have_access_to_env:
			'Tu cuenta no tiene acceso a este entorno',
		error_retrieving_auth:
			'Error al recuperar la información de autenticación',
		account_already_exists:
			'Ya existe una cuenta con esta dirección de correo electrónico',
		unexpected_error: 'Ha ocurrido un error inesperado.',
		loan_calculator_permissions: `No tienes permiso para actualizar los campos requeridos. Por favor, contacta a tu oficial de préstamos para actualizar el préstamo.`,
		unable_to_connect:
			'No se pudo conectar con el servidor. Por favor, verifica tu conexión a internet e inténtalo de nuevo.',
		request_timeout:
			'La solicitud tardó demasiado en completarse. Por favor, inténtalo de nuevo.',
		invalid_request:
			'Solicitud inválida. Por favor, revisa tu información e inténtalo de nuevo.',
		session_expired:
			'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
		no_permission: 'No tienes permiso para realizar esta acción.',
		resource_not_found: 'El recurso solicitado no fue encontrado.',
		request_conflict:
			'Hubo un conflicto con tu solicitud. Por favor, actualiza la página e inténtalo de nuevo.',
		invalid_input:
			'Por favor, revisa tu información e inténtalo de nuevo.',
		too_many_requests:
			'Demasiadas solicitudes. Por favor, espera un momento e inténtalo de nuevo.',
		request_issue:
			'Hubo un problema con tu solicitud. Por favor, inténtalo de nuevo.',
		unexpected_error_short: 'Ha ocurrido un error inesperado.',
		unexpected_error_retry:
			'Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo.',
	},
	landing: {
		mortgage_rates: 'Tasas hipotecarias',
		how_to_apply: '¿Cómo te gustaría aplicar?',
		apply_now: 'Aplicar ahora',
		what_would_you_like_today: '¿Qué te gustaría hacer hoy?',
		check_out_todays_rates: 'Consulta las tarifas de hoy',
		get_your_rate: 'Consigue tu tarifa',
		customer_testimonials: 'Testimonios de clientes',
		visit_linkedin: 'Visítanos en LinkedIn',
		visit_facebook: 'Visítanos en Facebook',
		visit_instagram: 'Visítanos en Instagram',
		visit_x: 'Visítanos en X',
		visit_youtube: 'Visítanos en YouTube',
	},
	legal: {
		website: 'Sitio web',
		contact_us: 'Contacta con nosotros',
		privacy_policy: 'Política de privacidad',
		terms: 'Condiciones de Uso',
		license_info: 'Información de licencia',
	},
	create_account: {
		title: 'Crear Cuenta',
		create_account: 'Crear una cuenta',
		please_wait: 'Espere mientras recuperamos su invitación.',
		invite_expired: 'La invitación ha caducado',
		request_new:
			'Solicite una nueva invitación a su oficial de préstamos',
		first_name: 'El primer nombre',
		last_name: 'El apellido',
		sign_up: 'Inscribirse',
	},
	mortgage: {
		fixed_15_years: 'Fija a 15 Años',
		conventional_30_years: 'Convencional a 30 años',
		todays_rates: 'Tarifas de Hoy',
		fixed: 'Tijas',
		conventional: 'Convencional',
	},
	alerts: {
		save_success: 'El {name} se actualizó correctamente',
		delete_success: 'El {name} se eliminó correctamente',
		sent_to_los:
			'El borrador del préstamo se ha enviado con éxito al LOS',
		pop_up_blocker_enabled:
			'¡El bloqueador de elementos emergentes está habilitado! Agregue este sitio a su lista de excepciones e intente nuevamente.',
		invites_success: 'Tus invitaciones se enviaron con éxito.',
		invites_failed: 'Hubo un problema al enviar tus invitaciones.',
		invite_sent_to: 'Invitación enviada a:',
		invite_success_to:
			'Invitación enviada con éxito a {emailAddress}',
		invite_failed_to:
			'Hubo un problema al enviar la invitación a {emailAddress}',
		pipeline_loading_error:
			'Hubo un problema al cargar las solicitudes',
	},
	dropzone: {
		instructions:
			'Arrastra y suelta archivos aquí o haz clic para seleccionar archivos',
		edit_file_name: 'Editar Nombre del Archivo',
		file_too_large: 'El archivo es mayor que {size} bytes',
		up_to_files: 'Hasta {size} archivos',
		up_to: 'Hasta',
	},
	task_verification: {
		default_button_title: 'Verifícame',
		manual_upload_button_title: 'Carga Manual',
		loan_locked_notice:
			'Tu préstamo está actualmente en uso. Una vez que se actualice, se enviarán tus mensajes de verificación.',
		success:
			'¡Éxito! Por favor, revisa tu bandeja de SMS o correo electrónico para los próximos pasos.',
		task_verification_copy_by_type: {
			VerificationOfAssets: {
				heading: 'Verifica tus activos financieros',
				body: `Haz clic en "Iniciar verificación" para recibir un mensaje de texto y un correo electrónico que te guiarán a través de la verificación de tus activos. Estos mensajes te ayudarán a iniciar sesión en tu cuenta bancaria en línea y seleccionar las cuentas que deseas compartir. Alternativamente, puedes subir tus estados de cuenta bancarios manualmente.`,
				button_title: `Iniciar verificación`,
			},
			VerificationOfIncome: {
				heading: 'Verifica tus ingresos',
				body: `Haz clic en "Iniciar verificación" para recibir un mensaje de texto y un correo electrónico que te guiarán a través de la verificación de tus INGRESOS. Estos mensajes te ayudarán a iniciar sesión en tu cuenta bancaria en línea y seleccionar las cuentas que deseas compartir. Alternativamente, puedes subir tus estados de cuenta bancarios manualmente.`,
				button_title: `Iniciar verificación`,
			},
			VerificationOfEmployment: {
				heading: 'Verifica tu empleo',
				body: `Haz clic en "Iniciar verificación" para recibir un mensaje de texto y un correo electrónico que te guiarán a través de la verificación de tu EMPLEO. Estos mensajes te ayudarán a iniciar sesión en tu cuenta bancaria en línea y seleccionar las cuentas que deseas compartir. Alternativamente, puedes subir tus estados de cuenta bancarios manualmente.`,
				button_title: `Iniciar verificación`,
			},
			VerificationOfIncomeAndEmployment: {
				heading: 'Verifica tus ingresos y empleo',
				body: `Haz clic en "Iniciar verificación" para recibir un mensaje de texto y un correo electrónico que te guiarán a través de la verificación de tus INGRESOS Y EMPLEO. Estos mensajes te ayudarán a iniciar sesión en tu cuenta bancaria en línea y seleccionar las cuentas que deseas compartir. Alternativamente, puedes subir tus estados de cuenta bancarios manualmente.`,
				button_title: `Iniciar verificación`,
			},
		},
	},
	task_form: {
		weight_helper_text:
			'El peso se utiliza para ordenar. Cuanto menor sea el número, más arriba se mostrará en la lista.',
		weight_label: 'Peso',
	},
	templates: {
		delete_version_prompt:
			'¿Estás seguro de que deseas eliminar esta versión?',
		delete_version: 'Eliminar versión',
		delete_selected_version: 'Eliminar versión seleccionada',
		save_as_new_version: 'Guardar como nueva versión',
		template_created: 'Plantilla creada con éxito',
		add_template_title: `Agregar plantilla de {name}`,
	},
	remove_record: {
		permanent_deletion: 'Eliminación Permanente',
		permanent_delete:
			'¿Eliminar permanentemente "{value}" y todos los datos asociados?',
		delete: 'Eliminar',
		cancel: 'Cancelar',
		confirm_delete: 'Confirmar Eliminación',
		confirm_permanent_deletion: 'Confirmar Eliminación Permanente',
		confirm_reactivate: 'Confirmar Reactivación',
		remove: 'Remover',
		restore: 'Restaurar',
		confirm_deletion: 'Sí, Eliminarlo',
		confirm_restore: 'Sí, Restaurarlo',
	},
	warnings: {
		no_revert_possible: 'ADVERTENCIA: ESTO NO SE PUEDE DESHACER',
		accept_no_revert_possible:
			'Al marcar esta casilla, confirmo que entiendo que esta acción no se puede deshacer.',
		change_email:
			'Cambiar tu dirección de correo electrónico puede desvincular invitaciones y asignaciones de préstamos existentes.',
		change_email_denied:
			'No tienes permiso para cambiar tu dirección de correo electrónico',
	},
	modals: {
		confirm_send_to_los: '¿Estás seguro de que deseas enviar a LOS?',
	},
	drafts: {
		send_to_los: 'Solicitud de préstamo',
	},
	invites: {
		send_invite: 'Enviar invitación',
		multi_invite: 'Invitación múltiple',
		pending_invites: 'Invitaciones Pendientes',
		econsent_title: 'Creando Cuentas de Usuario',
		econsent_disclaimer:
			'Se pedirá a los usuarios que den su consentimiento electrónico tan pronto como inicien sesión en su cuenta POS. Si no tienen una cuenta, simplemente invítelos haciendo clic en este botón:',
		invite_reminder: 'Recordatorio de invitación',
	},
	sso: {
		sso_integrations: 'Integraciones SSO',
		download_cc_metadata_file:
			'Descargar metadatos de Consumer Connect',
		download_bpos_metadata_file: 'Descargar metadatos de POS',
		regenerate_cc_metadata_file:
			'Regenerar metadatos de Consumer Connect',
		regenerate_bpos_metadata_file: 'Regenerar metadatos de POS',
	},
	form_validations: {
		empty_when_dont_send_selected:
			"Debe estar vacío cuando se selecciona 'No enviar'",
		at_least_one_borrower_selected:
			'Se debe seleccionar al menos un prestatario',
		select_document_template:
			'Por favor, seleccione una plantilla de documento',
		notification_option_required:
			'La opción de notificación es obligatoria',
	},
	mobile_settings: {
		heading: 'Configuración Móvil',
		has_mobile_switch: 'Habilitar Aplicación Móvil',
		mobile_app_url_label: 'URL de la Aplicación Móvil *',
		mobile_app_url_placeholder: 'URL de la Aplicación Móvil',
		mobile_app_url_required:
			'La URL de la Aplicación Móvil es obligatoria',
		mobile_app_url_invalid: 'Debe ser una URL válida',
		mobile_settings_success:
			'Configuración móvil actualizada con éxito',
		mobile_settings_error:
			'Error al actualizar la configuración móvil',
	},
	generate_loan_document: {
		generate_button_text: 'Generar Documento',
		notification_option: 'Opción de Notificación',
		select_borrowers: 'Seleccionar Prestatarios',
		dont_send: 'No enviar',
		send_to_all_borrowers: 'Enviar a todos los prestatarios',
		send_to_specific_borrowers: 'Enviar a prestatarios específicos',
		send_to_borrower: 'Enviar a {name}',
	},
	add_coborrower_form: {
		modal_heading: 'Agregar Prestatario Adicional',
		add_a_coborrower: 'Agregar un co-prestatario',
		method_heading:
			'Por favor, elija su método de entrada preferido...',
		invite_heading:
			'Ingrese la información de contacto del Co-prestatario...',
		send_invitation: 'Enviar Invitación',
		provide_information: 'Proporcionaré la Información',
		relationship:
			'¿Están usted y {name} casados o unidos en una unión civil?',
		married_civil_union: 'Casados/Unión Civil',
		disclaimer: {
			heading:
				'Por favor, revise la información a continuación. Si está satisfecho, haga clic en el botón de abajo para enviar la invitación.',
			body: 'Al hacer clic en el botón "Enviar Invitación" a continuación, reconoce que se enviará un correo electrónico y un mensaje de texto al destinatario. Pueden aplicarse tarifas de texto y datos.',
		},
		max_borrowers_reached:
			'Has alcanzado el número máximo de prestatarios.',
		loan_locked_notice:
			'No se puede agregar un Co-Deudor a un Archivo de Préstamo Bloqueado',
	},
	user_profile: {
		email_change: 'Activar cambio de correo electrónico',
	},
	workflow: {
		connected_sites: 'Sitios Conectados',
		available_sites: 'Sitios Disponibles',
	},
	entity_type: {
		account: 'Cuenta',
		branch: 'Sucursal',
		loan_officer: 'Oficial de Préstamos',
		partner: 'Agente inmobiliario',
		corporate: 'Marca',
	},
	loan_calculator: {
		submit: 'Actualizar Préstamo y Calcular Pago',
	},
	site_configuration: {
		loading: 'Cargando configuración, por favor espere',
		fetch_error: 'Error al recuperar la configuración del sitio',
		update_success:
			'La configuración del sitio se actualizó correctamente',
		update_error: 'Error al actualizar la configuración del sitio',
	},
	loan_settings: {
		heading: 'Configuración del Préstamo',
		exclude_from_auto_task_reminders:
			'Excluir de Recordatorios Automáticos de Tareas',
		missing_loan_id: 'El ID del préstamo es obligatorio',
		update_success: 'Configuración del préstamo actualizada',
	},
	auto_task_reminders: {
		title: 'Recordatorios Automáticos de Tareas',
		days: 'Días',
		before: 'Antes',
		after: 'Después',
		due_date: 'Fecha de Vencimiento',
		add_reminder: 'Agregar Recordatorio',
		on_due_date: 'En la Fecha de Vencimiento',
		submit_reminders: 'Configurar Recordatorios',
		open_settings: 'Abrir Configuración de Recordatorios',
		reminders_set: '{count} Recordatorios Establecidos',
		validation: {
			days: {
				min: 'Los días deben ser un número positivo',
				required: 'Los días son obligatorios',
			},
			sequence: {
				oneOf: 'La secuencia debe ser "antes" o "después"',
				required: 'La secuencia es obligatoria',
			},
			duplicate: 'El recordatorio ya existe',
		},
	},
	share_loan: {
		title: 'Compartir Préstamo',
	},
	pipeline: {
		my_applications: 'Mis Solicitudes',
		loan_applications: 'Solicitudes de Préstamo',
		loan_pipeline_tab: 'Pipeline de Préstamos',
		incomplete_loans_tab: 'Préstamos Incompletos',
		tabs_aria_label:
			'Pestañas de navegación para pipeline de préstamos y aplicaciones incompletas',
		expanded_row: {
			borrower: 'Prestatario',
			co_borrower: 'Co-Prestatario',
		},
		columns: {
			loan_number: 'Número de Préstamo',
			loan_amount: 'Monto del Préstamo',
			address: 'Dirección',
			application_date: 'Fecha de Solicitud',
		},
		not_yet_assigned: 'Aún no asignado',
		view_application: 'Ver Solicitud',
		impersonate: 'Suplantar',
	},
	loan_documents: {
		heading: 'Documentos del préstamo',
		download_modal: {
			heading: 'Descargar documentos',
			download_all: 'Descargar todo',
		},
		locked_upload_notice:
			'Sus cargas se están procesando y es posible que algunas acciones no estén disponibles. Por favor, vuelva más tarde para ver los cambios de estado.',
	},
	media_library: {
		rows_per_page_label: 'Elementos por página:',
		file_processing:
			'Este archivo todavía se está procesando. Por favor, vuelva más tarde para verlo.',
	},
	upload_media: {
		modal: {
			heading: 'Subir medios',
		},
		form: {
			accepted_file_types: 'Tipos de archivos aceptados:',
			required: 'Se requiere al menos 1 archivo',
			is_valid_type: 'Tipo de archivo no aceptado',
		},
		alerts: {
			upload_success: '{name} se subió correctamente',
		},
	},
}
